import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllCompanies = (params) => {
  const ENDPOINT = endPoints.getAllCompanies;

  const queryParams = new URLSearchParams();
  if (params.search) queryParams.append("search", params.search);
  if (params.page) queryParams.append("page", params.page);
  if (params.limit) queryParams.append("limit", params.limit);

  const finalUrl = queryParams.toString()
    ? `${ENDPOINT}?${queryParams.toString()}`
    : `${ENDPOINT}`;

  return Api(
    finalUrl,
    null,
    requestType.GET
  );
};

const getCompanyDetails = (id) => {
  return Api(`${endPoints.getCompanyDetails}/${id}`, null, requestType.GET);
};

const getAllCompanyForFilters = () => {
  return Api(endPoints.getAllCompanyForFilters, null, requestType.GET);
};

const deleteCompany = (id) => {
  return Api(`${endPoints.deleteCompany}/${id}`, null, requestType.GET);
};

const getCompanyServiceDetail = (companyId, subServiceId) => {
  return Api(
    `${endPoints.getCompanyServiceDetail}/${companyId}/${subServiceId}`,
    null,
    requestType.GET
  );
};

const getCompanyBySubServices = (payload) => {
  return Api(endPoints.getCompanyBySubServices, payload, requestType.POST);
};

const updateCompanyStatus = (id, params) => {
  return Api(`${endPoints.updateCompanyStatus}/${id}`, params, requestType.PUT);
};

export {
  getAllCompanies,
  getCompanyDetails,
  deleteCompany,
  getAllCompanyForFilters,
  getCompanyBySubServices,
  getCompanyServiceDetail,
  updateCompanyStatus,
};
